import { displayGet, displayJson, displayDelete } from '../../../services/displayApi';

export interface PlaylistMediaEntryApi {
  mediaId: string;
  sequenceNo: number;
  displayTime: number;
}

export interface PlaylistApiItem {
  id: string;
  locationId: string;
  name: string;
  orientation: 'LANDSCAPE' | 'PORTRAIT';
  mediaEntries: PlaylistMediaEntryApi[];
  createdAt: string;
  updatedAt: string;
}

export interface PlaylistSaveMediaEntry {
  mediaId: string;
  sequenceNo: number;
}

export interface PlaylistSavePayload {
  locationId: string;
  name: string;
  orientation: 'LANDSCAPE' | 'PORTRAIT';
  mediaEntries: PlaylistSaveMediaEntry[];
}

// NOTE: displayJson/displayGet/displayDelete all wrap the parsed response body as { data: rawBody },
// and the backend's raw body is itself { data: <payload>, message }. Callers must unwrap twice
// (res.data.data) — see playlistSaga.ts.

/** POST {DISPLAY_BASE}/display/playlist */
export const createPlaylistApi = (payload: PlaylistSavePayload) =>
  displayJson('/display/playlist', payload, 'POST') as Promise<{ data: { data: PlaylistApiItem; message?: string } }>;

/** GET {DISPLAY_BASE}/display/playlist?locationId= */
export const fetchPlaylistsApi = (locationId: string) =>
  displayGet(`/display/playlist?${new URLSearchParams({ locationId }).toString()}`) as Promise<{ data: { data: PlaylistApiItem[] } }>;

/** POST {DISPLAY_BASE}/display/playlist/{id} — update uses POST, not PATCH, per backend contract. */
export const updatePlaylistApi = (id: string, payload: PlaylistSavePayload) =>
  displayJson(`/display/playlist/${encodeURIComponent(id)}`, payload, 'POST') as Promise<{ data: { data: PlaylistApiItem; message?: string } }>;

export interface PlaylistDeleteApiResponse {
  id: string;
  deleted: boolean;
}

/** DELETE {DISPLAY_BASE}/display/playlist/{id}?locationId= */
export const deletePlaylistApi = (id: string, locationId: string) =>
  displayDelete(`/display/playlist/${encodeURIComponent(id)}?${new URLSearchParams({ locationId }).toString()}`, 'Failed to delete playlist') as Promise<{ data: { data: PlaylistDeleteApiResponse; message?: string } }>;
